import React, { useEffect, useRef } from 'react';
import { faClose, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import LinkButton from 'components/buttons/LinkButton/LinkButton';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import { Trans, useTranslation } from 'react-i18next';
import { useOnClickOutside } from 'utils/hooks/useOnClickOutside';
import { useSearchParams } from 'react-router-dom';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';
import { IProvider } from 'utils/hooks/http/providers.http';
import './ProviderFilter.scss';


type Props = {
  setOpenFilter?: (boolean) => void;
  openFilter?: boolean;
  filterData?: IProvider[];
  getData?;
};

const ProviderFilter: React.FC<Props> = (props) => {
  const { control, getValues, setValue } = useForm();
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const filterRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const { isMobile, isTablet } = useDeviceDetect();

  // useOnClickOutside(filterRef, () => {
  //   props.setOpenFilter!(false);
  // });


  const getOptions = () => {
    const newFilterData = props.filterData;

    return (
      newFilterData?.map((item) => ({
        label: item.name,
        value: item.code_fou,
      })) || []
    );
    
  };


  function handleClick() {
    const params = {
      page: '1',
      code_fou: getValues()?.provider?.value
    };

    const validParams = Object.entries(params).reduce((acc, [key, value]) => {
      if (!value || !value.length) {
        return acc;
      }

      acc[key] = value;

      return acc;
    }, {} as { [key: string]: string | string[] });
    
 
    setSearchParams(validParams);
    props.setOpenFilter!(false);
  }

  function handleReset() {
    setValue('provider', '');
    setSearchParams({page: '1'});
    props.setOpenFilter!(false);
  }

  useEffect(()=>{
    const foundProvider = props.filterData?.find(provider => provider.code_fou === searchParams.get('code_fou'));

    if(foundProvider){
      setValue('provider', {label: foundProvider?.name, value: foundProvider?.code_fou});
    }
  },[props.filterData]);

  return (
    <div ref={filterRef} className={`provider-filter  ${props.openFilter ? 'active' : ''}`}>
      <div className="header">
        <div className="buttons-container">
          <LinkButton title={t('_reset')} icon={faRedo} onClick={handleReset} />
        </div>
        <div onClick={() => props.setOpenFilter!(false)}>
          <FontAwesomeIcon className="icon" icon={faClose} />
        </div>
      </div>
      <div className="title">
        <Trans i18nKey="_filter_results" components={{ b: <strong /> }} />
      </div>
      <div className="filters">
        <div className="dropdowns-container">
          <div className="dropdown-item">
            <label className="dropdown-label">{t('_provider')}</label>
            <Controller
              control={control}
              name="provider"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value}
                  className="parts-filter-select-dropdown"
                  onChange={(val) => {
                    onChange(val);
                  }}
                  options={getOptions()}
                  placeholder={t('_provider')}
                  menuPlacement="auto"
                  menuPosition="fixed"
                  styles={{ menuPortal: base => ({ ...base, zIndex: 50 }) }}
                  isSearchable={!isMobile && !isTablet}
                />
              )}
            />
          </div>
        </div>
      </div>
      <div className="apply-btn">
        <DefaultButton text={t('_apply')} onClick={() => handleClick()} />
      </div>
    </div>
  );
};

export default ProviderFilter;
